module.exports = __webpack_public_path__ + "img/chevron-left-solid.486f67cb.svg";